import { useState } from "react"

function AddTodo(props){
    const[inputValue,setinputValue] =  useState("")
    var mylist = props.mylist
    var setmylist = props.setmylist
    function handleChange(e){
        setinputValue(e.target.value)
    }
    function handleAdd(){
        setmylist([...mylist,{id:mylist.length+1,activity:inputValue}])
        setinputValue("")

    }
    
    return (
        <div className=" flex flex-col gap-3">
            <h1 className="text-2xl font-medium">Manage Activities</h1>
            <div><input className="border border-black p-2" placeholder="Next Activity?" type="text" value={inputValue} onChange={handleChange}/>
            <button className="bg-black text-white p-2 border border-black" onClick={handleAdd}>Add</button></div>
        </div>
    )
}
export default AddTodo